import { render, staticRenderFns } from "./login.vue?vue&type=template&id=dae4c832&scoped=true&"
import script from "./login.ts?vue&type=script&lang=ts&"
export * from "./login.ts?vue&type=script&lang=ts&"
import style0 from "./login.scss?vue&type=style&index=0&id=dae4c832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae4c832",
  null
  
)

export default component.exports